import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/miranda-react/dist/tokens'

export const EmptyStateWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getToken('spacing-12')};
`
